/**
 * The reads behind the callback overbooking check and the slot picker:
 * GET /api/crm/callbacks/availability (range at most 14 days, one recruiter
 * per read) and, for the picker's Team mode, the study's roster. Over
 * `services/api`, never axios directly. The body is normalized, so callers can
 * trust every array and the booking window to be there.
 */
import api from '../../../services/api';
import { AvailabilityResponse, normalizeAvailability } from './slotLogic';

export async function getCallbackAvailability(
  q: { assignee: string; from: string; to: string; exclude?: string | null },
  signal?: AbortSignal,
): Promise<AvailabilityResponse> {
  const res = await api.get('/api/crm/callbacks/availability', {
    params: { assignee: q.assignee, from: q.from, to: q.to, ...(q.exclude ? { exclude: q.exclude } : {}) },
    signal,
  });
  return normalizeAvailability(res?.data);
}

/**
 * The study's recruiter roster (GET /api/crm/studies/:id/recruiters, any CRM
 * member), in routing order: the slot picker's Team mode columns. A roster
 * entry whose user no longer exists (`missing`) is left out.
 */
export async function getStudyRecruiters(
  studyId: string,
  signal?: AbortSignal,
): Promise<{ id: string; name: string | null }[]> {
  const res = await api.get(`/api/crm/studies/${studyId}/recruiters`, { signal });
  const rows: any[] = Array.isArray(res?.data?.recruiters) ? res.data.recruiters : [];
  return rows
    .filter((r) => r && typeof r.user_id === 'string' && r.user_id && !r.missing)
    .map((r) => ({ id: r.user_id as string, name: typeof r.name === 'string' && r.name ? r.name : null }));
}
